enum Pages {
  /** 官网首页 */
  Home = '/',

  /** 法律协议 */
  LegalDocuments = '/legal/documents',
  PrivacyPolicy = '/privacy-policy',
  UserAgreement = '/user-agreement',
  AiAutomatedServicesNotice = '/ai-automated-services-notice',
  CommunicationsAiCallsPolicy = '/communications-ai-calls-policy',
  CaliforniaPrivacyNotice = '/california-privacy-notice',

  /** H5 个人求职功能 */
  H5Home = '/h5',
  H5Invitation = '/h5/invitation',
  H5InvitationV2 = '/h5/invitation/v2',
  H5InvitationV3 = '/h5/invitation/v3',
  H5Rules = '/h5/invitation/rules',
  H5Download = '/h5/download',
  H5FieldAppDownload = '/h5/field-app/download',
  ReferralRules = '/referrals/rules',
  H5PublicPromotion = '/promotion',

  /** 地推 H5 */
  H5PromotionRoot = '/h5/promotion',
  H5PromotionLogin = '/h5/promotion/login',
  H5PromotionHome = '/h5/promotion',
  H5PromotionPerformance = '/h5/promotion/performance',
  H5PromotionReviews = '/h5/promotion/reviews',
  H5PromotionReviewDetail = '/h5/promotion/reviews/:accountId',
}

export default Pages;
